import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  FormControl,
  FormLabel,
  Heading,
  HStack,
  Input,
  NumberInput,
  NumberInputField,
  Select,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";

const initialForm = {
  customerName: "",
  customerEmail: "",
  planId: "",
  paymentMethodToken: "pm_card_visa",
};

const CreateSubscriptionPanel = ({
  onSubmit,
  plans,
  plansAvailable,
  plansLoading,
  onRefreshPlans,
  isSubmitting,
}) => {
  const [form, setForm] = useState(initialForm);

  const hasPlanOptions = plansAvailable && plans.length > 0;

  useEffect(() => {
    if (hasPlanOptions && !form.planId) {
      setForm((prev) => ({ ...prev, planId: String(plans[0].id) }));
    }
  }, [hasPlanOptions, plans, form.planId]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    const success = await onSubmit({
      ...form,
      planId: Number(form.planId),
    });
    if (success) {
      setForm(initialForm);
    }
  };

  return (
    <Card variant="outline" _hover={{ boxShadow: "md" }} transition="box-shadow 0.2s ease">
      <CardHeader>
        <Heading size="sm">Create Subscription</Heading>
      </CardHeader>
      <CardBody>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
          <FormControl>
            <FormLabel>Customer Name</FormLabel>
            <Input value={form.customerName} onChange={(e) => handleChange("customerName", e.target.value)} />
          </FormControl>
          <FormControl>
            <FormLabel>Customer Email</FormLabel>
            <Input
              type="email"
              value={form.customerEmail}
              onChange={(e) => handleChange("customerEmail", e.target.value)}
            />
          </FormControl>
          <FormControl>
            <FormLabel>Plan</FormLabel>
            {hasPlanOptions ? (
              <Select
                value={form.planId}
                onChange={(e) => handleChange("planId", e.target.value)}
                isDisabled={plansLoading}
              >
                {plans.map((plan) => (
                  <option key={plan.id} value={plan.id}>
                    {plan.name} ({plan.currency} {plan.amount})
                  </option>
                ))}
              </Select>
            ) : (
              <NumberInput
                min={1}
                value={form.planId}
                onChange={(valueString) => handleChange("planId", valueString)}
              >
                <NumberInputField placeholder="Plan ID" />
              </NumberInput>
            )}
            {!hasPlanOptions ? (
              <HStack mt={2} justify="space-between">
                <Text fontSize="xs" color="gray.500">
                  {plansAvailable
                    ? "No plans available yet. Enter a plan ID manually."
                    : "Plan list unavailable. Enter a plan ID manually."}
                </Text>
                <Button size="xs" variant="link" onClick={onRefreshPlans} isDisabled={plansLoading}>
                  Try fetching plans
                </Button>
              </HStack>
            ) : null}
          </FormControl>
          <FormControl>
            <FormLabel>Payment Method Token</FormLabel>
            <Input
              value={form.paymentMethodToken}
              onChange={(e) => handleChange("paymentMethodToken", e.target.value)}
            />
          </FormControl>
        </SimpleGrid>
        <Button mt={4} colorScheme="blue" onClick={handleSubmit} isLoading={isSubmitting}>
          Create Subscription
        </Button>
      </CardBody>
    </Card>
  );
};

export default CreateSubscriptionPanel;
